import httpClient from '@/libs/http-client'
import { HTTP_HEADER_SKIP_ERROR } from '@/libs/constants'

export function requestCapture (sid, urlId, matchType, targetUrl, device, captureUrl) {
  const config = {
    headers: {
      [HTTP_HEADER_SKIP_ERROR]: '1'
    }
  }

  const url = '/ba/capture/sitemap'
  const params = {
    sid,
    urlId,
    matchType,
    url: targetUrl,
    device,
    captureUrl,
    serviceCode: 1,
    fileType: 'png'
  }

  return httpClient.post(url, params, config).then(response => {
    return response.data.result.data
  })
}

export function requestPreviewCapture (data) {
  const url = '/capture/preview'

  return httpClient.post(url, data).then(response => {
    return response.data.result.data
  })
}

export function getPreviewCaptureStatus (id, uuid) {
  const url = `/capture/preview_status/${id}/${uuid}`

  return httpClient.get(url).then(response => {
    return response.data.result.data
  })
}

export function checkCaptureExist (sid, urlId, matchType, targetUrl) {
  const config = {
    headers: {
      [HTTP_HEADER_SKIP_ERROR]: '1'
    }
  }

  const url = '/ba/capture/sitemap/get_data'
  const params = {
    sid,
    urlId,
    matchType
  }

  if (targetUrl) {
    params.url = targetUrl
  }

  return httpClient.post(url, params, config).then(response => {
    return response.data.result
  })
}
